/**
 * Product Variant Hover System
 * - Image preloading
 * - Hover: swap image + badge + active class
 * - Mouseleave: restore original badge
 * - Click: persist variant + badge + price + cart + links + clicked class
 * - Badge injection if missing
 * - Unified badge handling with emojis
 */
(function() {
  // 1) Emoji map
  console.log('hover.js ok')
  const STATUS_EMOJIS = {
    'TRENDING':         '🚀',
    'HOT':              '🔥',
    'NORTHWEEK CHOICE': '⭐',
    'LAST UNITS':       '⏱️'
  };

  // 2) Init
  document.addEventListener('DOMContentLoaded', initializeVariantHover);
  document.addEventListener('shopify:section:load', initializeVariantHover);

  function initializeVariantHover() {
    document.querySelectorAll('.product-card-wrapper, li[id^="Slide-"]')
      .forEach(card => initializeCard(card));
  }

  function initializeCard(card) {
    const thumbsContainer = card.querySelector('.product__variant-thumbs');
    if (!thumbsContainer) return;

    // 3) Badge: get or inject
    let badge = card.querySelector('.special-status-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'special-status-badge nx-status-badge';
      badge.setAttribute('hidden','');
      const media = card.querySelector('.card__media');
      if (media) media.appendChild(badge);
    }
    // store original badge
    const defaultBadge = {
      html:    badge.innerHTML,
      visible: !badge.hasAttribute('hidden')
               && window.getComputedStyle(badge).display !== 'none'
    };

        // 4) Main image
    let mainImage = null;
    const mainId = thumbsContainer.dataset.mainImageId;
    if (mainId) mainImage = document.getElementById(mainId);
    if (!mainImage) {
      mainImage = card.querySelector('img.card-main-image')
               || card.querySelector('.card__media img');
    }
    if (!mainImage) return;

    // 4b) Secondary image (Dawn's hover effect — the second <img> inside .media)
    const mediaContainer = card.querySelector('.media.media--hover-effect');
    const secondaryImage = mediaContainer ? mediaContainer.querySelector('img + img') : null;


    // 5) Other elements
    const productName  = card.querySelector('.product-title-link, .card__heading a');
    const productPrice = card.querySelector('.price');
    const productLinks = card.querySelectorAll('a.full-unstyled-link');
    const cartForm     = card.querySelector('.cart-btn-form');
    const cartButton   = card.querySelector('.add-to-cart-btn');
    const cartContainer= card.querySelector('.card-product__add-to-cart');

    // 6) Inject main-thumb if missing
    let mainThumb = thumbsContainer.querySelector('.main-product-thumb');
    if (!mainThumb) {
      mainThumb = document.createElement('div');
      mainThumb.className = 'variant-thumb main-product-thumb';
      mainThumb.dataset.image         = mainImage.dataset.default || mainImage.src;
      mainThumb.dataset.title         = productName?.textContent.trim() || '';
      mainThumb.dataset.price         = productPrice?.innerHTML || '';
      mainThumb.dataset.variantId     = cartForm?.querySelector('input[name="id"]')?.value || '';
      mainThumb.dataset.available     = cartForm ? 'true' : 'false';
      mainThumb.dataset.specialStatus = defaultBadge.html.replace(/<[^>]+>/g,'').trim();
      mainThumb.dataset.productUrl    = card.querySelector('a.full-unstyled-link')?.href || '';

      const img = document.createElement('img');
      img.src = mainThumb.dataset.image.replace('533','100');
      img.alt = mainThumb.dataset.title;
      mainThumb.appendChild(img);
      thumbsContainer.insertBefore(mainThumb, thumbsContainer.firstChild);
    }

    // 7) Collect thumbnails
    const thumbs = thumbsContainer.querySelectorAll('.variant-thumb');
    if (!thumbs.length) return;

    // 8) Preload images
    thumbs.forEach(t => new Image().src = t.dataset.image);

    thumbs.forEach(t => setupEvents(
      t, mainImage, secondaryImage, productName, productPrice, productLinks,
      badge, cartForm, cartButton, cartContainer, thumbs, defaultBadge
    ));


    // 10) Mark main as active
    mainThumb.classList.add('active');
    setupScroll(card, thumbsContainer);
  }

  function setupEvents(
    thumb, mainImage, secondaryImage, productName, productPrice, productLinks,
    badge, cartForm, cartButton, cartContainer, thumbs, defaultBadge
  ) {

    const imgSrc     = thumb.dataset.image;
    const name       = thumb.dataset.title;
    const price      = thumb.dataset.price;
    const rawStatus  = thumb.dataset.specialStatus || '';
    const status     = rawStatus.trim();
    const variantId  = thumb.dataset.variantId;
    const available  = thumb.dataset.available === 'true';
    const url        = thumb.dataset.productUrl;

        // Hover
    thumb.addEventListener('mouseenter', () => {
      window.requestAnimationFrame(() => {
        // image
        mainImage.src = imgSrc;
        if (mainImage.hasAttribute('srcset')) mainImage.removeAttribute('srcset');
        // Hide the secondary image so it doesn't overlap the swapped main image
        if (secondaryImage) secondaryImage.style.display = 'none';
        // Force main image visible (in case CSS hover hid it)
        mainImage.style.opacity = '1';
        // active class
        thumbs.forEach(x => x.classList.remove('active'));
        thumb.classList.add('active');
        // badge
        updateBadge(badge, status, defaultBadge);
      });
    });


        // Mouseleave — revert image + active class back to clicked/original thumb
    thumb.addEventListener('mouseleave', () => {
      // Find the thumb that was clicked, or fallback to the main product thumb
      const persistedThumb = [...thumbs].find(x => x.classList.contains('clicked'))
                          || [...thumbs].find(x => x.classList.contains('main-product-thumb'));

      if (persistedThumb) {
        // Revert main image to the clicked/original thumb's image
        mainImage.src = persistedThumb.dataset.image;
        if (mainImage.hasAttribute('srcset')) mainImage.removeAttribute('srcset');
        // Restore active class to that thumb
        thumbs.forEach(x => x.classList.remove('active'));
        persistedThumb.classList.add('active');
      }

      // Restore the secondary image so CSS hover effect works again
      if (secondaryImage) secondaryImage.style.display = '';
      // Remove forced opacity so CSS can control it again
      mainImage.style.opacity = '';

      // Revert badge to default
      updateBadge(badge, '', defaultBadge);
    });



            // Click
    thumb.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      // image
      mainImage.src = imgSrc;
      if (mainImage.hasAttribute('srcset')) mainImage.removeAttribute('srcset');

      // Update the secondary (hover) image to match the clicked variant's second image
      const secondarySrc = thumb.dataset.secondaryImage;
      if (secondaryImage && secondarySrc) {
        secondaryImage.src = secondarySrc;
        if (secondaryImage.hasAttribute('srcset')) secondaryImage.removeAttribute('srcset');
        // Show it again so CSS hover effect works with the new image
        secondaryImage.style.display = '';
      } else if (secondaryImage) {
        // If this variant has no secondary image, hide it
        secondaryImage.style.display = 'none';
      }
      mainImage.style.opacity = '';

      // name/price
      if (productName && name)   productName.textContent = name;
      if (productPrice && price) productPrice.innerHTML   = price;
      // badge persists
      updateBadge(badge, status, defaultBadge);
      // cart
      updateCart(cartForm, cartButton, cartContainer, variantId, available);
      // links
      productLinks.forEach(l => l.href = url);
      // clicked class
      thumbs.forEach(x => x.classList.remove('clicked','active'));
      thumb.classList.add('clicked','active');
    });

  }

  function updateBadge(badge, status, def) {
    if (status) {
      const e = STATUS_EMOJIS[status]||'';
      badge.innerHTML    = `<span class="emoji">${e}</span> ${status}`;
      badge.style.display= ''; badge.removeAttribute('hidden');
    } else if (def) {
      badge.innerHTML = def.html;
      if (def.visible) {
        badge.style.display=''; badge.removeAttribute('hidden');
      } else {
        badge.style.display='none'; badge.setAttribute('hidden','');
      }
    }
  }

  function updateCart(form, btn, ctr, vid, ok) {
    if (!form||!btn) return;
    const input = form.querySelector('input[name="id"]');
    if (input && vid) input.value = vid;
    btn.disabled = !ok;
    if (ok) {
      btn.classList.remove('disabled','sold-out');
      if (ctr) ctr.style.display='';
    } else {
      btn.classList.add('disabled','sold-out');
      if (ctr) ctr.style.display='none';
    }
  }

  function setupScroll(card, container) {
    const left  = card.querySelector('.left-arrow');
    const right = card.querySelector('.right-arrow');
    if (left)  left.addEventListener('click', e=>{ e.preventDefault(); e.stopPropagation(); container.scrollBy({left:-100,behavior:'smooth'}); });
    if (right) right.addEventListener('click',e=>{ e.preventDefault(); e.stopPropagation(); container.scrollBy({left:100, behavior:'smooth'}); });
  }

  function fixClicks() {
    document.querySelectorAll('.product__variant-thumbs-wrapper, .variant-thumb-arrow')
      .forEach(el => {
        el.addEventListener('click',    e=>e.stopPropagation());
        el.addEventListener('mousedown',e=>e.stopPropagation());
      });
  }
  document.addEventListener('DOMContentLoaded', fixClicks);
  document.addEventListener('shopify:section:load', fixClicks);
})();
